import { gql } from 'apollo-angular';

export const mutationLogin = gql`
mutation ambassadorLogin($operationID: String, $email: String, $password: String, $rememberMe: Boolean){
    AmbassadorLogin(operationID: $operationID, email: $email, password: $password, rememberMe: $rememberMe){
        ID
        referenceID
        firstName
        lastName
        responses {
          ID
          challengeID
          typeResponse
          response
          status
          message
          date
          matchID         
          incentive
          devise
          points
          ambassadorLevel
          challengeLevel
          comment
          optionalsMedias
        }
        matches{
          ID
          widgetID
          tester{
            firstName
            lastName
            gender
            email
            phone
          }
          validation {
           tester{
              hasValidated
           }
           owner{
              hasValidated
           }
          }
          status
          nbSales
          salesDeniedDefinitely
          _{
            created
          }
        }
        isTestUser
        isVisible
        acceptNotifications
        terms
        email
        phone
        languageID
        gender
        pictureURL
        biography
        address{
          streetNumber
          route
          city
          country
          postalCode
        }
        gps {
          type
          coordinates
        }
        productIDs
        status
        externalsDatas
        questions {
            ID
            product {
                name
            }
            tester{
                firstName
                lastName
            }
            object
            content
            responses {
              ambassadorID
              response
              responseDate
            }
            status
            _ {
                created
            }
        }
        shopOrders {
            ID  
            shopProduct {
                ID
                title               
                media                
            }
            quantity
            costInPointsTotal
            status
            message
            _ {
                created
            }
        }
        pwaAnalytics {
            stories {
                storyID
                created
            }
        }
        _pcd {
          level
          top
          ranking
          points
          amountPoints
          amountGlady
          amountPaid
          rewards
          rewardHistory {
              type
              title
              devise
              incentive
              points
              level
              date
              isVisio
              tester {
                firstName
                lastName
              }
          }
          score {
            publications
            reviews
            events
            externals
            demonstrations
            sales
          }
          updated
        }    
        _{            
          updated
        }    
    }
}
`;

export const mutationLogout = gql`
mutation logout{
    Logout
}
`;

export const mutationSignup = gql`
mutation ambassadorSignup ($params: String ) {
    AmbassadorSignup(params: $params ) { 
        ID
        referenceID
        firstName
        lastName
        responses {
          ID
          challengeID
          typeResponse
          response
          status
          message
          date
          matchID         
          incentive
          devise
          points
          ambassadorLevel
          challengeLevel
          comment
          optionalsMedias
        }
        matches{
          ID
          widgetID
          tester{
            firstName
            lastName
            gender
            email
            phone
          }
          validation {
           tester{
              hasValidated
           }
           owner{
              hasValidated
           }
          }
          status
          nbSales
          salesDeniedDefinitely
          _{
            created
          }
        }
        isTestUser
        isVisible
        acceptNotifications
        terms
        email
        phone
        languageID
        gender
        pictureURL
        biography
        address{
          streetNumber
          route
          city
          country
          postalCode
        }
        gps {
          type
          coordinates
        }
        productIDs
        status
        externalsDatas
        questions {
            ID
            product {
                name
            }
            tester{
                firstName
                lastName
            }
            object
            content
            responses {
              ambassadorID
              response
              responseDate
            } 
            status
            _ {
                created
            }
        }
        shopOrders {
            ID  
            shopProduct {
                ID
                title               
                media                
            }
            quantity
            costInPointsTotal
            status
            message
            _ {
                created
            }
        }
        pwaAnalytics {
            stories {
                storyID
                created
            }
        }
        _pcd {
          level
          top
          ranking
          points
          amountPoints
          amountGlady
          amountPaid
          rewards
          rewardHistory {
              type
              title
              devise
              incentive
              points
              level
              date
              isVisio
              tester {
                firstName
                lastName
              }
          }
          score {
            publications
            reviews
            events
            externals
            demonstrations
            sales
          }
          updated
        }
        _{            
          updated
        }
    }
}
`;

export const mutationRequestPasswordRecovery = gql`
mutation ambassadorRequestPasswordRecovery($operationID: String, $email: String){
    AmbassadorRequestPasswordRecovery(operationID: $operationID, email: $email)
}
`;

export const mutationValidatePasswordRecovery = gql`
mutation ambassadorValidatePasswordRecovery($token: String, $password : String){
    AmbassadorValidatePasswordRecovery(token: $token, password: $password){
        ID
        referenceID
        firstName
        lastName
        responses {
          ID
          challengeID
          typeResponse
          response
          status
          message
          date
          matchID         
          incentive
          devise
          points
          ambassadorLevel
          challengeLevel
          comment
          optionalsMedias
        }
        matches{
          ID
          widgetID
          tester{
            firstName
            lastName
            gender
            email
            phone
          }
          validation {
           tester{
              hasValidated
           }
           owner{
              hasValidated
           }
          }
          status
          nbSales
          salesDeniedDefinitely
          _{
            created
          }
        }
        isTestUser
        isVisible
        acceptNotifications
        terms
        email
        phone
        languageID
        gender
        pictureURL
        biography
        address{
          streetNumber
          route
          city
          country
          postalCode
        }
        gps {
          type
          coordinates
        }
        productIDs
        status
        externalsDatas
        questions {
            ID
            product {
                name
            }
            tester{
                firstName
                lastName
            }
            object
            content
            responses {
              ambassadorID
              response
              responseDate
            }
            status
            _ {
                created
            }
        }
        shopOrders {
            ID  
            shopProduct {
                ID
                title               
                media                
            }
            quantity
            costInPointsTotal
            status
            message
            _ {
                created
            }
        }
        pwaAnalytics {
            stories {
                storyID
                created
            }
        }
        _pcd {
          level
          top
          ranking
          points
          amountPoints
          amountGlady
          amountPaid
          rewards
          rewardHistory {
              type
              title
              devise
              incentive
              points
              level
              date
              isVisio
              tester {
                firstName
                lastName
              }
          }
          score {
            publications
            reviews
            events
            externals
            demonstrations
            sales
          }
          updated
        }    
        _{            
          updated
        }    
    }
}
`;

export const queryMe = gql`
  query Me{
    Me{
        ID
        referenceID
        firstName
        lastName
        responses {
          ID
          challengeID
          typeResponse
          response
          status
          message
          date
          matchID         
          incentive
          devise
          points
          ambassadorLevel
          challengeLevel
          comment
          optionalsMedias
        }
        matches{
          ID
          widgetID
          tester{
            firstName
            lastName
            gender
            email
            phone
          }
          validation {
           tester{
              hasValidated
           }
           owner{
              hasValidated
           }
          }
          status
          nbSales
          salesDeniedDefinitely
          _{
            created
          }
        }
        isTestUser
        isVisible
        acceptNotifications
        terms
        email
        phone
        languageID
        gender
        pictureURL
        biography
        address{
          streetNumber
          route
          city
          country
          postalCode
        }
        gps {
          type
          coordinates
        }
        productIDs
        status
        externalsDatas
        questions {
            ID
            product {
                name
            }
            tester{
                firstName
                lastName
            }
            object
            content
            responses {
              ambassadorID
              response
              responseDate
            } 
            status
            _ {
                created
            }
        }
        shopOrders {
            ID  
            shopProduct {
                ID
                title               
                media                
            }
            quantity
            costInPointsTotal
            status
            message
            _ {
                created
            }
        }
        pwaAnalytics {
            stories {
                storyID
                created
            }
        }
        _pcd {
          level
          top
          ranking
          points
          amountPoints
          amountGlady
          amountPaid
          rewards
          rewardHistory {
              type
              title
              devise
              incentive
              points
              level
              date
              isVisio
              tester {
                firstName
                lastName
              }
          }
          score {
            publications
            reviews
            events
            externals
            demonstrations
            sales
          }
          updated
        }
        _{            
          updated
        }
    }
}`;

export const mutationPreviewLogin = gql`
mutation ambassadorPreviewLogin($operationID: String, $ID: String){
    AmbassadorPreviewLogin(operationID: $operationID, ID: $ID){
        ID
        referenceID
        firstName
        lastName
        responses {
          ID
          challengeID
          typeResponse
          response
          status
          message
          date
          matchID         
          incentive
          devise
          points
          ambassadorLevel
          challengeLevel
          comment
          optionalsMedias
        }
        matches{
          ID
          widgetID
          tester{
            firstName
            lastName
            gender
            email
            phone
          }
          validation {
           tester{
              hasValidated
           }
           owner{
              hasValidated
           }
          }
          status
          nbSales
          salesDeniedDefinitely
          _{
            created
          }
        }
        isTestUser
        isVisible
        acceptNotifications
        terms
        email
        phone
        languageID
        gender
        pictureURL
        biography
        address{
          streetNumber
          route
          city
          country
          postalCode
        }
        gps {
          type
          coordinates
        }
        productIDs
        status
        externalsDatas
        questions {
            ID
            product {
                name
            }
            tester{
                firstName
                lastName
            }
            object
            content
            responses {
              ambassadorID
              response
              responseDate
            } 
            status
            _ {
                created
            }
        }
        shopOrders {
            ID  
            shopProduct {
                ID
                title               
                media                
            }
            quantity
            costInPointsTotal
            status
            message
            _ {
                created
            }
        }
        pwaAnalytics {
            stories {
                storyID
                created
            }
        }
        _pcd {
          level
          top
          ranking
          points
          amountPoints
          amountGlady
          amountPaid
          rewards
          rewardHistory {
              type
              title
              devise
              incentive
              points
              level
              date
              isVisio
              tester {
                firstName
                lastName
              }
          }
          score {
            publications
            reviews
            events
            externals
            demonstrations
            sales
          }
          updated
        }
        _{            
          updated
        }
    }
}
`;